import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Proptypes from "prop-types";
import Button from "@shared/v2/Button";
import { Popover, PopoverContent, PopoverItem, PopoverTrigger } from "@shared/v2/Popover";
import Plus from "@shared/v2/Icomoon/Icons/Plus";
import useMlsListingDetails from "@shared/MlsListingDropdown/useMlsListingDetails";
import { CREATE_MEDIA_OPTIONS } from "../api/helpers";

const getFilterStatus = (status = "") => {
  const normalizedStatus = status.trim().toLowerCase();

  const listedStatuses = ["active"];
  const soldStatuses = ["sold", "closed", "off market"];
  const underContractStatuses = ["pending", "active under contract", "active with contingency"];

  if (listedStatuses.includes(normalizedStatus)) {
    return "listed";
  }

  if (soldStatuses.includes(normalizedStatus)) {
    return "sold";
  }

  if (underContractStatuses.includes(normalizedStatus)) {
    return "underContract";
  }

  return "sold";
};

const MarketingHeaderOptions = ({ mlsID, mlsNumber, type, blossorId }) => {
  const [filterStatus, setFilterStatus] = useState("");
  const mlsListingDetails = useMlsListingDetails(blossorId);
  const standardStatus = mlsListingDetails?.data?.standardStatus || "";

  useEffect(() => {
    if (standardStatus) {
      setFilterStatus(getFilterStatus(standardStatus));
    }
  }, [standardStatus]);

  return (
    <div className="tw-flex tw-gap-4px">
      {mlsNumber && mlsID && (
        <Popover>
          <PopoverTrigger>
            <Button className="tw-ml-auto tw-flex tw-gap-4px tw-items-center" schema="secondary" size="small">
              <Plus size="s" />
              Create
            </Button>
          </PopoverTrigger>
          <PopoverContent>
            {CREATE_MEDIA_OPTIONS.map(
              (option) =>
                (mlsID || option.name !== "Social Media Ad") && (
                  <PopoverItem
                    key={option.name}
                    onClick={() =>
                      window.open(
                        `${option.url}?mlsNum=${mlsNumber}&blueroofMlsId=${mlsID}&filter=${filterStatus}`,
                        "_blank",
                      )
                    }
                  >
                    {option.name}
                  </PopoverItem>
                ),
            )}
          </PopoverContent>
        </Popover>
      )}

      {type === "seller" && mlsNumber && mlsID && (
        <Button
          className="tw-ml-auto tw-flex tw-gap-4px tw-items-center"
          schema="primary"
          size="small"
          onClick={() =>
            window.open(
              `/launch?slug=brivity-marketer&redirectPath=${encodeURIComponent(`/lmp/${mlsID}/${mlsNumber}`)}`,
              "_blank",
            )
          }
        >
          View Marketing Package
        </Button>
      )}
    </div>
  );
};

MarketingHeaderOptions.propTypes = {
  mlsID: Proptypes.string,
  mlsNumber: Proptypes.string,
  type: Proptypes.string,
  blossorId: Proptypes.string,
};

MarketingHeaderOptions.defaultProps = {
  mlsID: null,
  mlsNumber: null,
  type: "",
  blossorId: "",
};

const mapStateToProps = (state) => ({
  mlsID: state.tdpMarketingReducer.mlsID,
  mlsNumber: state.tdpDetailsReducer.listingDetails.mls_number,
  blossorId: state.tdpMarketingReducer.assetsCardViews?.external_interactions?.blossor_id,
  type: state.tdpDetailsReducer.headerDetails?.type,
});

export default connect(mapStateToProps)(MarketingHeaderOptions);
